module.exports = __webpack_public_path__ + "media/images/edit-dc6748b15739da6922cd3db613fed00a.svg";